import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { SuccessTag } from '../SuccessTag/SuccessTag'
import { AccountAvatar } from 'components/PostPreviewModalV2/components/AccountToggle/AccountAvatar'
import { MetaAdsFacebookPage } from '../Types'

export const FacebookAccountCard = ({
  account,
  isSelected,
  onSelect,
}: {
  account: MetaAdsFacebookPage
  isSelected: boolean
  onSelect: () => void
}) => {
  const additionalData = account.additional_data ?? {}
  const followerCount = additionalData.fan_count ?? 0

  return (
    <div className={Styles.card}>
      <div className={Styles.cardLeft}>
        <input
          type="radio"
          name="facebookPage"
          value={account.provider_id}
          checked={isSelected}
          onChange={onSelect}
          aria-label={`Select Facebook Page ${account.name}`}
          className={Styles.radioInput}
        />
        <AccountAvatar account={account} />
        <div className={Styles.accountInfo}>
          <Text variant="primary" fontWeight="600">
            {account.name}
          </Text>

          <Text variant="secondary">
            <div className={Styles.secondaryAccountInfo}>
              {followerCount} Followers ID: {account.provider_id}
            </div>
          </Text>
        </div>
      </div>
      <div className={Styles.cardRight}>
        {isSelected ? (
          <SuccessTag text="Selected" />
        ) : (
          <Button variant="ghost" size="sm" onPress={onSelect}>
            Use This Page
          </Button>
        )}
      </div>
    </div>
  )
}
